import React from "react";
import { Link } from "react-router-dom";
import "./ContactSpirit.css";

const ContactSpirit = () => {
  return (
    <div className="contact-container">
      <div className="contact-card">
        <h2>Contact Spirit</h2>
        <p>Hey Ye you can contact me in several ways listed below:</p>

        <p>
          X:{" "}
          <a className="contact-card2" href="https://x.com/spiritraps" target="_blank" rel="noreferrer">
            X.com/spiritraps
          </a>{" "}
          (DM)
        </p>
        <p>
          Instagram:{" "}
          <a className="contact-card2"
            href="https://instagram.com/spiritraps"
            target="_blank"
            rel="noreferrer"
          >
            Instagram.com/spiritraps
          </a>{" "}
          (DM)
        </p>
        <p>
          Email:{" "}
          <a href="mailto:spiritrealm@spiritrealm.live">
            spiritrealm@spiritrealm.live
          </a>
        </p>

        <p>- Spirit</p>
        <Link to="/" className="back-btn">
          ←
        </Link>
      </div>
    </div>
  );
};

export default ContactSpirit;
